


import React from "react";
// import MamakSidebar from "../Sidebar/MamakSidebar";
// import MamakOtherServices from "../ServiceAreas/MamakServiceAreas";
import BadgeSection from "../../BadgeSection";

const MamakIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      {/* Breadcrumb */}
      <div className="text-sm text-gray-600 mb-4">
        <span className="underline">Ana Sayfa</span> &nbsp;&gt;&nbsp; <span className="underline">Hizmet Bölgeleri</span> &nbsp;&gt;&nbsp; Mamak
      </div>

      {/* Başlık */}
      <h1 className="text-3xl text-center font-bold text-[#003132] mb-4">MAMAK HALI VE KOLTUK YIKAMA</h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* Sol sidebarlar */}
        <div className="space-y-6">
          {/* <MamakSidebar />
          <MamakOtherServices /> */}
        </div>

        {/* İçerik */}
        <div className="md:col-span-2 space-y-6">
          <p>
            **Mamak'ta profesyonel halı ve koltuk yıkama hizmetleriyle hijyen ve kaliteyi evinize getiriyoruz!**  
           Abone Halı Yıkama olarak, halılarınızı, koltuklarınızı ve ev tekstili ürünlerinizi en gelişmiş teknolojilerle temizliyor, %100 müşteri memnuniyetiyle teslim ediyoruz.
          </p>

          <p>
            **Kutludüğün, Hürel, Mutlu, Şahintepe, Akdere, Kıbrısköyü** ve diğer Mamak mahallelerinde **mobil servis araçlarımız** ile  
            **yerinden alım ve zamanında teslim** hizmeti sağlıyoruz. Böylece temizlik sürecini zahmetsiz hale getiriyoruz.
          </p>

          <h2 className="text-lg font-semibold text-[#003132]">Mamak'ta NedenAbone Halı Yıkama?</h2>
          <ul className="list-disc list-inside">
            <li>**Derinlemesine temizlik:** Halı ve koltuklarınızın dokusuna zarar vermeden hijyen sağlıyoruz</li>
            <li>**Antibakteriyel ve hijyen garantisi** – Sağlıklı yaşam için profesyonel çözümler</li>
            <li>**Leke çıkarma garantisi** – Zorlu lekeleri özel tekniklerle yok ediyoruz!</li>
            <li>**Buhar ve vakum sistemleri ile hijyenik temizlik**</li>
            <li>**Kimyasal kalıntı bırakmayan çevre dostu temizlik ürünleri**</li>
            <li>**Kısa sürede teslimat ve güvenli paketleme**</li>
          </ul>

          <p>
            **Mamak'ın her noktasına hızlı hizmet!**  
            Halı ve koltuk yıkamada **özel şampuanlar ve buhar sistemleri** kullanarak **derinlemesine hijyen sağlıyoruz**.
          </p>

          <p>
            **Ev tekstili yıkama hizmetleri:**  
            Yorgan, perde, battaniye gibi ürünleri **antibakteriyel yıkama** ile temizleyerek evinizde sağlıklı bir atmosfer oluşturuyoruz.
          </p>

          <p>
            **Mamak'ta zahmetsiz temizlik garantisiyle hizmet veriyoruz!**  
            Hemen <strong>İletişim</strong> sayfamızdan bize ulaşarak sipariş verebilir veya fiyat bilgisi alabilirsiniz!
          </p>
        </div>

        {/* Rozetler */}
        <div className="space-y-6">
          <BadgeSection />
        </div>
      </div>
    </div>
  );
};

export default MamakIntro;
